import { render } from "./QuestionnaireFailed.vue?vue&type=template&id=36a17d70&scoped=true"
import script from "./QuestionnaireFailed.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFailed.vue?vue&type=script&lang=js"

import "./QuestionnaireFailed.vue?vue&type=style&index=0&id=36a17d70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a17d70"]])

export default __exports__